import { useState } from "react";

import Button from "components/ui/button/Button";
import Tooltip from "components/ui/tooltip/Tooltip";
import { useAllBuyersSaved } from "lib/hooks/api/buyer_lists/useAllBuyersSaved";
import { BuyersModal } from "./BuyersModal";

type Props = {
  buyerGuids: string[];
};

/**
 * Notice-preview action for a notice with several buyers: opens the buyer list so a subset can
 * be picked before saving. Mirrors BulkSaveNoticeSupplier.
 */
function BulkSaveNoticeBuyer({ buyerGuids }: Props) {
  const [open, setOpen] = useState(false);

  const { allSaved, isLoading } = useAllBuyersSaved(buyerGuids);

  const tooltip = `Save ${buyerGuids.length} buyers to a list`;

  return (
    <div>
      <BuyersModal open={open} onOpenChange={setOpen} guids={buyerGuids} />
      <Tooltip content={tooltip}>
        <Button
          buttonType="secondary"
          icon="bookmark"
          aria-label={tooltip}
          // Square, to match the single-buyer button beside it
          width={32}
          // Without a fill the bookmark inherits one and renders solid, which reads as saved.
          iconProps={{ fill: isLoading || !allSaved ? "transparent" : "sysPrimaryDefault" }}
          loading={isLoading}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
    </div>
  );
}

export default BulkSaveNoticeBuyer;
